import React from 'react';
import './ProductGridSkeleton.css';

function ProductGridSkeleton({ count = 10 }) {
  return (
    <div className="product-grid">
      {Array.from({ length: count }).map((_, idx) => (
        <div className="product-card skeleton" key={idx}>
          <div className="skeleton-img shimmer"></div>
          <div className="skeleton-line shimmer" style={{ width: '80%' }}></div>
          <div className="skeleton-line shimmer" style={{ width: '60%' }}></div>
          <div className="skeleton-line shimmer" style={{ width: '40%' }}></div>
        </div>
      ))}
    </div>
  );
}

export default ProductGridSkeleton; 